import { SUBMIT_SERVICE_REQUEST} from "../actionTypes";
import { SubmitServiceRequest } from "../../../api/newService/newService.service";

const request = () => ({ type: SUBMIT_SERVICE_REQUEST.REQUEST });
const failure = (error) => ({ type: SUBMIT_SERVICE_REQUEST.FAILURE, error });
const success = () => ({ type: SUBMIT_SERVICE_REQUEST.SUCCESS });

export const SubmitRequst = (payload) => {
  return (dispatch, getState) => {
    dispatch(request());
    return SubmitServiceRequest(payload)
      .then((res) => {
        dispatch(success(res));
        return Promise.resolve({res:res,status:true});

      })
      .catch((error) => {
        dispatch(failure(error?.message));
        return Promise.resolve({error:error?.message,status:false,code:error?.code,});
      });
  };
};
